import { EntityGridList } from "@/modules/common/components";
import { Pagination } from "@/modules/common/types/Pagination";
import { AdminManagementCompanyResponse } from "@/service/response/admin-management-companies";
import ManagerListHeader from "./ManagerListHeader";
import ManagerListLine from "./ManagerListLine";
import ManagerListSkeleton from "./ManagerListSkeleton";

interface ManagersListParams {
  data?: Pagination<AdminManagementCompanyResponse>;
  onInactivate?: (manager: AdminManagementCompanyResponse) => void;
  isLoading?: boolean;
  isFetching?: boolean;
  limit?: number;
  onChangePage: (nextPage: number) => void;
  onChangePageSize: (nextSize: number) => void;
}

const ManagersList = ({ onInactivate, ...props }: ManagersListParams) => (
  <EntityGridList
    {...props}
    minWidthClassName="md:min-w-[1380px]"
    renderHeader={() => <ManagerListHeader />}
    renderRow={(manager) => <ManagerListLine manager={manager} onInactivate={onInactivate} />}
    renderSkeleton={(limit) => <ManagerListSkeleton limit={limit} />}
  />
);

export default ManagersList;
